module.exports = __webpack_public_path__ + "static/img/yg.f5b8972.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lang/yg.png
// module id = ASls
// module chunks = 1